// Thermal die-cut detection (DYMO LabelWriter-class rolls). Used for the
// rounded-corner preview + tests. NOTE: a forced "feed-orientation" rotation of
// the print page lived here from 2026-06-27 (dev-time "DYMO print fix") until
// 2026-08-24; it was removed after it printed a customer's labels sideways with
// a blank page 2. The classic editor never rotated and worked for years —
// print exactly as designed. If a real "shifted/blank DYMO print" report ever
// arrives, get the driver/OS details before reintroducing anything.
import type { LabelSize } from './types'

const DIECUT_BRANDS = ['dymo']
const NON_DIECUT_CATEGORIES = ['tape', 'continuous', 'sheet', 'document']

export function isThermalDieCut(size: LabelSize): boolean {
  const brand = (size.brand || '').toLowerCase()
  const cat = (size.category || '').toLowerCase()
  if (NON_DIECUT_CATEGORIES.includes(cat)) return false
  return DIECUT_BRANDS.includes(brand)
}
